// src/redux/slices/authSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { encryptToken } from '../../Utlis/Encryption';

const storedEncryptedToken = localStorage.getItem("token");
const storedUser = localStorage.getItem("user");
const storedInviteProfileUpdateToken = localStorage.getItem("inviteProfileUpdateToken");
const storedCompany = localStorage.getItem("company");
function safeParse(item) {
  if (!item || item === "undefined" || item === "null") return null;
  try {
    return JSON.parse(item);
  } catch (e) {
    console.error("Failed to parse item from localStorage:", e);
    return null;
  }
}
const initialState = {
  token: storedEncryptedToken || null,
  //  user: storedUser ? JSON.parse(storedUser) : null,
  //    company: storedCompany ? JSON.parse(storedCompany) : null, 
  user: safeParse(storedUser),
  company: safeParse(storedCompany),
  otpData: null,
  resetToken: null,
  profileUpdateToken: null,
  inviteProfileUpdateToken: storedInviteProfileUpdateToken || null, // invite flow
  inviteEmail: null,
  trialInfo: null,

};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { token, user, company } = action.payload;
      const encryptedToken = encryptToken(token);
      state.token = encryptedToken;
      state.user = user;
      state.trialInfo = action.payload.trialInfo;
      state.company = company;
      if (company) {
        localStorage.setItem("company", JSON.stringify(company)); // 👈 persist
      }
      console.log("📦 [authSlice] setCredentials triggered");
      console.log("🔐 Encrypted Token stored:", encryptedToken);
      console.log("👤 User stored:", user);
      console.log("🏢 Company received in payload:", company);   // 👈 check payload

      console.log("Encrypted token before storing:", encryptedToken);
      localStorage.setItem("token", encryptedToken);
      localStorage.setItem("token", encryptedToken);
      localStorage.setItem("user", JSON.stringify(user));
    },
    setOtpData: (state, action) => {
      state.otpData = action.payload; // 👈 email and otp
    },
    setResetToken: (state, action) => {
      state.resetToken = action.payload; // ✅ Set the token
    },
    setProfileUpdateToken: (state, action) => {
      state.profileUpdateToken = action.payload;
    },
    setInviteProfileUpdateToken: (state, action) => {
      state.inviteProfileUpdateToken = action.payload;
      localStorage.setItem("inviteProfileUpdateToken", action.payload);
    },
    setInviteEmail: (state, action) => {   // ✅ new reducer
      state.inviteEmail = action.payload;
    },
    clearInviteCredentials: (state) => {
      state.inviteProfileUpdateToken = null;
      state.inviteEmail = null;
      localStorage.removeItem("inviteProfileUpdateToken");
      localStorage.removeItem("inviteEmail");
    },
    logout: (state) => {
      state.token = null;
      state.user = null;
      state.trialInfo = null;
      state.otpData = null;
      state.profileUpdateToken = null;
      localStorage.removeItem("token");
      localStorage.removeItem("profileUpdateToken");
      localStorage.removeItem("inviteProfileUpdateToken");
      state.inviteEmail = null;
    }
  },
});

export const { setCredentials, logout, setOtpData, setResetToken, setProfileUpdateToken, setInviteEmail,
  setInviteProfileUpdateToken, clearInviteCredentials,
} = authSlice.actions;
export default authSlice.reducer;

